import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getLabTransaction = (formData) => {
    return axiosInstance.post(`api/lab-transaction/list`, formData);
}
